/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NotificationChannelsResChannels,
    NotificationChannelsResChannelsFromJSON,
    NotificationChannelsResChannelsFromJSONTyped,
    NotificationChannelsResChannelsToJSON,
} from './';

/**
 * 
 * @export
 * @interface NotificationChannelsRes
 */
export interface NotificationChannelsRes {
    /**
     * 
     * @type {Array<NotificationChannelsResChannels>}
     * @memberof NotificationChannelsRes
     */
    channels: Array<NotificationChannelsResChannels>;
}

export function NotificationChannelsResFromJSON(json: any): NotificationChannelsRes {
    return NotificationChannelsResFromJSONTyped(json, false);
}

export function NotificationChannelsResFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationChannelsRes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'channels': ((json['channels'] as Array<any>).map(NotificationChannelsResChannelsFromJSON)),
    };
}

export function NotificationChannelsResToJSON(value?: NotificationChannelsRes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'channels': ((value.channels as Array<any>).map(NotificationChannelsResChannelsToJSON)),
    };
}


